export enum ERROR_LABELS {
  REQUIRED_FIELD = "ERROR_REQUIREDFIELD",
  POD_NOT_SAME_POL = "ERROR_POD_NOT_SAME_POL",
  POL_NOT_SAME_POD = "ERROR_POL_NOT_SAME_POD",
  MAX_N_WEIGHT_EXCEEDED = "ERROR_MAX_N_WEIGHT_EXCEEDED",
  MAX_N_EXCEEDED = "ERROR_MAX_N_EXCEEDED",
  INVALID_POSTCODE = "ERROR_INVALID_POSTCODE",
  INVALID_PHONE = "ERROR_INVALID_PHONE",
  INVALID_EMAIL = "ERROR_INVALID_EMAIL",
  INVALID_EMAILS = "ERROR_INVALID_EMAILS",
  OPTION_REQUIRED = "ERROR_REQUIRED_OPTION",
  REQUIRED_CARGO_LINE = "ERROR_REQUIRED_CARGO_LINE",
  GREATER_THAN_N = "ERROR_GREATER_THAN_N",
  MAX_N_CHAR_EXCEEDED = "ERROR_MAX_N_CHAR_EXCEEDED",
  MIN_N_CHARACTERS = "ERROR_MIN_CHARACTERS_NEEDED",
  REQUIRED_WHEN_COMMODITY_SELECTED = "ERROR_WHEN_COMMODITY_SELECTED_REQUIRED",
  REQUIRED_WHEN_TYPE_SELECTED = "ERROR_WHEN_TYPE_SELECTED_REQUIRED",
  REQUIRED_WHEN_QUANTITY_SELECTED = "ERROR_WHEN_QUANTITY_SELECTED_REQUIRED",
  REQUIRED_SELECTION = "ERROR_SELECT_OPTION_REQUIRED",
  SOMETHING_WRONG = "ERROR_GENERAL",
}
export enum TRANSLATION_LABELS {
  NO_ADDRESS_PROVIDED = "LABEL_NO_ADDRESS_PROVIDED",
}

export enum QUOTE_REASON_LABELS {
  Other = "LABEL_OTHER",
  AnotherCompany = "LABEL_QUOTE_DECLINE_ANOTHER_COMPANY",
  NoTransportNeed = "LABEL_QUOTE_DECLINE_NO_TRANSPORT",
}

export enum SELECT_LABELS {
  NO_OPTIONS = "INFO_SEARCH_NO_OPTIONS",
  DEFAULT_OPTIONS_MESSAGE = "INFO_SEARCH_DEFAULT_OPTIONS_MESSAGE",
}
